// @ts-nocheck
/* eslint-disable */
export const calendarIcon = {
    data: `<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="8.50012" y="9.5" width="15" height="14" rx="1.5" stroke="currentColor"/><path d="M23 14H9" stroke="currentColor"/><path d="M12 10.5V8.5" stroke="currentColor" stroke-linecap="round"/><path d="M20 10.5V8.5" stroke="currentColor" stroke-linecap="round"/></svg>`,
    name: 'calendar' as const
};